export function angularXeditableRun (editableOptions) {
  'ngInject'

  editableOptions.theme = 'bs3'
}
